<form [formGroup]="form">
  <div class="block justify-center overscroll-contain w-full">
    @if (hinAssignment; as assignment) {
      @if (showHidden || !assignment.hidden) {
        <vs-form-field
          class="col-span-2 w-full"
          [config]="{ label: (assignment.displayLabel || assignment.property.name) + ':' }"
        >
          @if (assignment.helpText) {
            <span slot="hint" class="text-gray-600 text-sm">{{ assignment.helpText }}</span>
          }
          <vs-input-group class="w-full">
            <input
              vsInput
              type="text"
              class="w-full rounded-b-none"
              [formControlName]="assignment.property.valueKey"
              placeholder="Enter vessel HIN"
            />
          </vs-input-group>
        </vs-form-field>
      }
    }

    <div class="border justify-center rounded-b-md w-full block grid-cols-2 gap-3 overscroll-contain -mt-px">
      <div class="flex flex-row gap-2 items-center">
        <button class="self-center" vs-icon-button appearance="clear" size="md" (click)="toggle()">
          <vs-icon [name]="expanded ? 'chevron-up' : 'chevron-down'"></vs-icon>
        </button>
        <label class="font-semibold text-sm">Marine Vessel Information:</label>
        @if (getSummaryValue('manufacturer'); as manufacturer) {
          <label class="text-sm text-gray-700 font-semibold gap-2 text-center">
            {{ manufacturer }}
          </label>
        }
        @if (getSummaryValue('modelYear'); as modelYear) {
          <label class="text-sm text-gray-700 font-semibold gap-2 text-center">
            {{ modelYear }}
          </label>
        }
        @if (form.invalid) {
          <span class="text-danger text-xs font-medium">Required details missing</span>
        }
      </div>

      @if (expanded) {
        <div class="px-2 py-3 w-full">
          <ng-container *ngFor="let assignment of visibleExpandedAssignments">
            @if (showHidden || !assignment.hidden) {
              <vs-property-input-form-field
                class="col-span-2 pt-2"
                [property]="assignment.property"
                [required]="assignment.required"
                [hidden]="assignment.hidden"
                [showHidden]="showHidden"
                [displayLabel]="assignment.displayLabel"
                [helpText]="assignment.helpText"
                [formControlName]="assignment.property.valueKey"
              >
              </vs-property-input-form-field>
            }
          </ng-container>
        </div>
      }
    </div>

    @if (hinControl?.touched && hinControl?.hasError('required')) {
      <span class="flex-col justify-center text-danger-500 font-medium text-sm ml-1 mt-1" slot="warning">
        HIN is required!
      </span>
    }

    @if (hinControl?.touched && hinControl?.hasError('invalidHin')) {
      <span class="flex-col justify-center text-danger-500 font-medium text-sm ml-1 mt-1" slot="warning">
        Enter a valid 12-character HIN.
      </span>
    }
  </div>
</form>
